import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";
import { ClientDetailsPdf } from "./Components/ClientDetails";
import { INDIVIDUAL_SESSION_REPORT_QUESTIONS, REPORT_QUESTIONS, TREATMENT_SUMMARY_REPORT_QUESTIONS } from "config/constants";
import RenderAnswer, { RenderAnswerByQId } from "./Components/AnswerFields/Index";
import TherapistSignaturePdf from "./Components/TherapistSignature";
import KhanReportLogoPdf from "./Components/KhanReportLogoPdf";
import { dateFormat, formatString, getAge } from "helpers/common";
import GoalReviewSection from "./Components/GoalReviewSection";
import TreatmentSummaryGoalsPreviewPdf from "./Components/TreatmentSummaryGoalsPreviewPdf";
import ReportFooter from "./Components/ReportFooter";

// Create styles
const styles = StyleSheet.create({
  header: {
    alignItems: "center",
    justifyContent: "center"
  },
  logo: {
    width: "20%",
  },
  tableRow: {
    ...globalStyles.tableRow,
    paddingVertical: "10px"
  },
});

export const TreatmentSummaryReportPdfDoc = ({ data, images }) => {
  const reportHeading = data?.assesment?.report_heading;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const reportAnswers = data?.assesmentData?.reportAnswers;
  const assessmentGoals = data?.assesmentData?.reportGoals;
  
  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist }

  return (
    <Document>
      <Page size="A4" style={globalStyles.page}>

        {/* Report Header */}
        <View style={[globalStyles.section, styles.header]}>
          <Image
            style={styles.logo}
            src={logo}
          />
          <Text style={globalStyles.reportHeading}>{reportHeading}</Text>
        </View>
        <View style={globalStyles.section}>

          {/* Client Details */}
          <ClientDetailsPdf
            data={data}
          />

        </View>

        {/* Questions & Answers */}
        <View style={globalStyles.section}>
          {reportQuestions?.length > 0 &&
            reportQuestions?.map((question, index) => {
              let foundAnswer = reportAnswers?.length && reportAnswers.find(answer => answer.question_id === question.id);
              if (
                [
                  TREATMENT_SUMMARY_REPORT_QUESTIONS.notes,
                  TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_clinical,
                  TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_goals,
                  TREATMENT_SUMMARY_REPORT_QUESTIONS.recommendation,
                  TREATMENT_SUMMARY_REPORT_QUESTIONS.greeting,
                ].includes(question.id)
              ) {
                return null;
              }

              return (
                <RenderAnswer
                  key={index}
                  question={question}
                  answer={foundAnswer}
                />
              );
            })
          }
        </View>

        <View style={globalStyles.section}>

          <TreatmentSummaryGoalsPreviewPdf
            data={
              reportAnswers?.length &&
              reportAnswers.find(answer =>
                answer.question_id === TREATMENT_SUMMARY_REPORT_QUESTIONS.treatment_summary
              )
            }
            notes={
              reportAnswers?.length &&
              reportAnswers.find(answer =>
                answer.question_id === TREATMENT_SUMMARY_REPORT_QUESTIONS.goal_notes
              )
            }
            images={images}
          />

          {
            [
              TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_clinical,
              TREATMENT_SUMMARY_REPORT_QUESTIONS.recommendation,
              TREATMENT_SUMMARY_REPORT_QUESTIONS.greeting
            ].map((qId, index) => (
              <RenderAnswerByQId
                key={index}
                questionId={qId}
                reportQuestions={reportQuestions}
                reportAnswers={reportAnswers}
                showQuestion={qId !== TREATMENT_SUMMARY_REPORT_QUESTIONS.greeting}
              />
            ))
          }

          {/* Therapist Signature */}
          <View style={globalStyles.reportQuestionOuter} wrap={false}>
            <TherapistSignaturePdf
              therapistDetails={therapistDetails}
            />
          </View>

          {/* Branding */}
          <View style={globalStyles.reportQuestionOuter} wrap={false}>
            <KhanReportLogoPdf />
          </View>
        </View>

        <ReportFooter
          data={data}
        />
      </Page>
    </Document>
  )
};
